// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1WXU-","col":"styles_col__2gPHe"};